import { render, staticRenderFns } from "./EducationalServiceDetail.vue?vue&type=template&id=6032c39b&scoped=true"
import script from "./EducationalServiceDetail.vue?vue&type=script&lang=js"
export * from "./EducationalServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./EducationalServiceDetail.vue?vue&type=style&index=0&id=6032c39b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6032c39b",
  null
  
)

export default component.exports